export class EFormChangeHistory {
    ID: number;
    TemplateId: number;
    TemplateAuditId: number;
    InstanceId: number;
    InstanceAuditId: number;
    ChangeDate: Date;
    ChangeBy: number;
    ObjectType: string;
    FieldId: number;
    Property: string;
    FieldName: string;
    Language: string;
    OldValue: string;
    NewValue: string;
    ChangeByName: string;

   }